import { Briefcase } from "lucide-react";

// 3. Executive Summary
const ExecutiveSummary = () => {
  return (
    <div className="bg-white rounded-lg shadow p-6 mb-6">
      <div className="flex items-center gap-3 mb-4">
        <Briefcase className="h-6 w-6 text-blue-600" />
        <h3 className="text-lg font-medium text-gray-900">Executive Summary</h3>
      </div>
      <div className="prose max-w-none">
        <p className="text-gray-600">
          GoFood is a well-established food truck company serving high-quality, fast-casual meals across various locations in Boston. With a strong local brand, the company has expanded its fleet and customer base while maintaining solid financial performance.
        </p>

        <p className="mt-4 text-gray-700">
          The valuation of GoFood has been conducted using the <strong>Discounted Cash Flow (DCF) Method</strong>, <strong>Market Comparables Analysis</strong>, and an <strong>Asset-Based Approach</strong> to determine an accurate value. These methods ensure a comprehensive and balanced understanding of the business's current market value and potential growth.
        </p>

        <div className="mt-6 bg-blue-100 border-l-4 border-blue-500 p-4 rounded">
          <p className="text-blue-800 text-xl font-semibold">📌 Estimated Business Valuation: $5 million</p>
        </div>

        <ul className="mt-6 space-y-2 text-gray-600">
          <li>
            <strong>Discounted Cash Flow (DCF) Method:</strong> Focuses on future cash flow projections to assess the intrinsic value of the business.
          </li>
          <li>
            <strong>Market Comparables Analysis:</strong> Evaluates GoFood's performance relative to similar businesses in the industry.
          </li>
          <li>
            <strong>Asset-Based Approach:</strong> Calculates the company's value based on its tangible and intangible assets.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ExecutiveSummary;
